/**
 * apps/web :: pass :: passRoutes
 *
 * The route registry the pass nested router (`PassApp`) iterates over.
 * Each Wave-1 screen exported a `PassRouteDescriptor[]` from its own
 * `screens/*.routes.tsx`; Wave 2 collects them here — the single shared-file
 * wiring step, so every screen stayed self-contained during the parallel build.
 *
 * The descriptor with `path: ''` (the pack home) becomes the index route.
 */
import type { PassRouteDescriptor } from "./routeDescriptor";
import { passHomeRoutes } from "./screens/passHome.routes";
import { rulePackRoutes } from "./screens/rulePack.routes";
import { tripLifecycleRoutes } from "./screens/tripLifecycle.routes";
import { coursewareRoutes } from "./screens/courseware.routes";
import { geofenceWaitlistRoutes } from "./screens/geofenceWaitlist.routes";

export const PASS_ROUTES: PassRouteDescriptor[] = [
  ...passHomeRoutes,
  ...rulePackRoutes,
  ...tripLifecycleRoutes,
  ...coursewareRoutes,
  ...geofenceWaitlistRoutes,
];
